<template>
  <div class="subscription-cancel-container">
    <p>Sorry to see you go!</p>
    If there is anything we can do for you, please use the feedback form and let us know how to improve!
  </div>
</template>

<script>
export default {
  name: 'SubscriptionCancel',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.subscription-cancel-container {
  padding: 50px 0px;
}
</style>